import { render, staticRenderFns } from "./processChecklistNonRiskbook.vue?vue&type=template&id=3a8746a6"
import script from "./processChecklistNonRiskbook.vue?vue&type=script&lang=js"
export * from "./processChecklistNonRiskbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8746a6')) {
      api.createRecord('3a8746a6', component.options)
    } else {
      api.reload('3a8746a6', component.options)
    }
    module.hot.accept("./processChecklistNonRiskbook.vue?vue&type=template&id=3a8746a6", function () {
      api.rerender('3a8746a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processChecklistNonRiskbook.vue"
export default component.exports